import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import type { DotProps as Props } from './types';

export const Dot = memo(
  ({
    className,
    width = 10,
    height = 10,
    color = 'primary.400',
    sx,
    ...other
  }: Props) => {
    return (
      <Box
        className={classnames('Dot', className)}
        sx={{
          width,
          height,
          borderRadius: '50%',
          bgcolor: color,
          ...sx,
        }}
        {...other}
      />
    );
  }
);

Dot.displayName = 'Dot';
